import { Col, Row } from "react-bootstrap";
import PrivateNotes from "./PrivateNotes";
import Communication from "./Communication";
const ContactCommunication = ({ refetch }: { refetch: () => void }) => {
  return (
    <Row>

      <Col lg={8}>
        <Communication />
      </Col>
      <Col lg={4}>
        <PrivateNotes refetch={refetch} />
      </Col>
    </Row>
  );
};

export default ContactCommunication;
